export class LoadPlaylist {
  static readonly type = '[Playlist] Load Playlist';

  constructor(readonly slug: string) {}
}
